import React from 'react';
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux';

import { CookiesProvider } from 'react-cookie';

import App from './components/App';


import store from './store';

const root = createRoot(document.getElementById("root"));

root.render(
    <CookiesProvider>
        <Provider store={store}>
            <App />
        </Provider>
    </CookiesProvider>    
);